import type { HTMLAttributes, Ref } from 'react';

import { cn } from '@shared/lib/cn';

import { MENU_CLASS, MENU_SKELETON_BAR_CLASS, MENU_SKELETON_ROW_CLASS } from './menu.constant';

export interface MenuSkeletonProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  ref?: Ref<HTMLDivElement>;
}

/** Menu 의 status=init — 줄 3개에 길이가 다른 막대(120 · 100 · 80). 불러오는 중(`aria-busy`) */
export function MenuSkeleton({ className, ...rest }: MenuSkeletonProps) {
  return (
    <div
      aria-busy="true"
      data-status="init"
      {...rest}
      className={cn('skeleton-pulse', MENU_CLASS, className)}
    >
      {MENU_SKELETON_BAR_CLASS.map((bar) => (
        <div key={bar} aria-hidden="true" className={MENU_SKELETON_ROW_CLASS}>
          <span className={cn('h-3 max-w-full rounded-full bg-bg-pressed', bar)} />
        </div>
      ))}
    </div>
  );
}
